/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
export const contentFooterClassName = 'smart-link-content-footer';
export const metadataListClassName = 'smart-link-metadata-list';
export const blockCardResolvingViewClassName = 'block-card-resolving-view';
export const blockCardResolvedViewClassName = 'block-card-resolved-view';
export const blockCardResolvedViewByClassName = 'block-card-resolved-view-by';
export const blockCardForbiddenViewClassName = 'block-card-forbidden-view';
export const blockCardForbiddenViewLinkClassName = 'block-card-forbidden-view-link';

/**
 * @deprecated Use `import { blockCardIconImageClassName } from '@atlaskit/smart-card/icon'` instead.
 */
export { blockCardIconImageClassName } from './view/common/Icon';
export const blockCardContentClassName = 'block-card-content';
export const blockCardContentHeaderClassName = 'block-card-content-header';
export const blockCardContentHeaderNameClassName = 'block-card-content-header-name';
export const blockCardNotFoundViewClassName = 'block-card-not-found-view';
export const blockCardErroredViewClassName = 'block-card-errored-view';

export const loadingPlaceholderClassName = 'smart-link-loading-placeholder';
